const MIMES = {
  'application/vnd.ms-excel': {
    extension: 'xls',
    downloadable: true
  },
  'text/html': {
    extension: 'html',
    downloadable: false
  },
  'application/pdf': {
    extension: 'pdf',
    downloadable: true
  }
};

export default MIMES;
